module.exports = __webpack_public_path__ + "img/j6.d9f96a51.png";